import React from "react";
import { NoDataAvailableDiv } from "../../../components/NoDataAvailableDiv";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  items: server.dto.ICalendarFeedSmall[]
}

const Row = ({ item }: { item: server.dto.ICalendarFeedSmall }) => (
  <tr className="hoverable" onClick={() => {
    window.location.href = routes.personal_ICalendarFeed_Detail(item.iCalendarFeedId).absolute;
  }}>
    <td className="table-main-link">
      {item.title}
    </td>
  </tr>
);

export default class ICalendarFeedsPanel extends React.Component<Props> {
  public render(): JSX.Element {
    if (this.props.items.length === 0) {
      return (<NoDataAvailableDiv />);
    }

    return (
      <>
        <table className="s1_table list">
          <tbody>
            {this.props.items.map((feed) => (
              <Row
                key={feed.iCalendarFeedId}
                item={feed}
              />
            ))}
          </tbody>
        </table>
      </>
    );
  }
}
